import type { ReactNode } from 'react';

import { cx } from '@/shared/lib/cx';

import styles from './status-screen.module.scss';

export type StatusScreenProps = {
  eyebrow?: string | undefined;
  title: string;
  children?: ReactNode;
  actions?: ReactNode;
  className?: string | undefined;
  /** h1 for standalone pages, h2 inside a page that already has a heading. */
  level?: 1 | 2;
};

/** Centered message for 404, errors, empty states and placeholder pages. */
export function StatusScreen({
  eyebrow,
  title,
  children,
  actions,
  className,
  level = 1,
}: StatusScreenProps) {
  const Heading = level === 1 ? 'h1' : 'h2';
  return (
    <section className={cx(styles.root, className)}>
      {eyebrow && <p className={styles.eyebrow}>{eyebrow}</p>}
      <Heading className={styles.title}>{title}</Heading>
      {children && <div className={styles.text}>{children}</div>}
      {actions && <div className={styles.actions}>{actions}</div>}
    </section>
  );
}
